const state = {
  announcement: '',
  announcementIsWarning: false
}

const mutations = {
  SET_ANNOUNCEMENT(state, announcement) {
    if (announcement) {
      state.announcement = announcement
    } else {
      state.announcement = ''
    }
  },
  SET_ANNOUNCEMENT_WARNING(state) {
    state.announcementIsWarning = true
  },
  CLEAR_ANNOUNCEMENT(state) {
    state.announcement = ''
    state.announcementIsWarning = false
  }
}

export const notifications = { namepsaced: true, state, mutations }
